import React from "react";
import { Image } from 'semantic-ui-react';
import './index.css';

const ObjectITButton = () => {
  return (
    <Image
      src="/developed-by-objectit.svg"
      as="a"
      href="http://objectit.com.au/"
      target="_blank"
      rel="noopener noreferrer"
      alt="Developed by Objectit"
      height="auto"
      width={140}
      className="sidebar-logo"
    />
  );
};

export default ObjectITButton;



// WEBPACK FOOTER //
// ./src/components/developed_by_objectit/index.js